var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagamentos"},[_c('va-card',{staticClass:"chart-widget",attrs:{"title":"Renovações nos ultimos 30 dias"}},[_c('line-chart',{staticClass:"chart",attrs:{"chart-data":_vm.paymentsData,"options":_vm.options}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }